<template>
    <nav class="menu-container">

      <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
      四海站<br>
站点介绍<br>
四海站位于工业八路和南海大道交叉路口下方。沿南海大道南北向敷设，规划与 15 号线四海站（在建）采用侧岛换乘，15 号线为地下一层侧式站台车站，四海站采用地下两层岛式站台车站，远期在车站西侧设置 15 号线费付费区过轨通道，满足乘客付费区及非付费区连通。本站为地下二层岛式车站，站台宽度为 14m。站位周边主要有豪芳悠然居（住宅)、花园城三期（住宅）、花园城商业中心、沃尔玛（商业）、四海加油站、花样年美年华国际广场（住宅）华龙大厦更新项目等类型建筑，是蛇口片区文创、娱乐、居住、商业、城市综合体集中区域。客流较为集中，片区出行需求 量较大。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
左炮台东	06:12	23:08	12号线	4分钟	8分钟<br>
海上田园东	06:39	00:03	12号线	4分钟	8分钟<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
左炮台东	06:16	23:08	12号线	8分钟	8分钟<br>
海上田园东	06:41	00:03	12号线	8分钟	8分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
左炮台东	－	－	12号线	－	－<br>
海上田园东	－	－	12号线	－	－<br><br>

站点出口信息<br><br>
A 出入口:<br>
南海大道东南侧 ，花园城三期 ，蛇口人民医院，四海公园<br><br>
D出入口:<br>
南海大道东北侧 ，四海小区<br><br>
E 出入口:<br>
南海大道西北侧<br><br>
F 出入口:<br>
工业八路西北侧<br><br>
J 出入口:<br>
工业八路西南侧 ，花园城五期<br>
公交换乘信息<br>

  </nav>
  </template>

  <script>
  // import Icon from "@/components/Icon";
  export default {
    components: {
      // Icon,
    },
    data() {
      return {
        items: [
          {
            name: "shierhaoxian",
            title: "12号线",
            // icon: "chat",
            exact: true,
          },
        ],
      };
    },
  };
  </script>

  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(50, 95, 227);
      }
    }
  }
  </style>